import { useSelector } from "react-redux";

import { isSameDay } from "utils/date";
import { getProviderNoteTitle } from "utils/report";
import {
  NOTE_SAVE_HANDLERS,
  useNoteSaveHandlerRegistry,
} from "../notes/NoteSaveHandlersContext";

/**
 * Unsaved report-page notes for useUnsavedChanges: `hasUnsavedNotes` (store flags) and
 * `getUnsavedNotes()` (asks each note panel on leaving).
 */
const useUnsavedNotes = () => {
  const registry = useNoteSaveHandlerRegistry();
  const {
    clinicNotesTouched,
    providerNotesTouched,
    reportNotesTouched,
    isReportNoteEditable,
    billableDate,
    originalBillableDate,
    reportDetail,
  } = useSelector((state) => state.transmission);
  const { accountsMapper } = useSelector((state) => state.account);

  const hasUnsavedNotes =
    clinicNotesTouched ||
    providerNotesTouched ||
    reportNotesTouched ||
    (isReportNoteEditable && !isSameDay(billableDate, originalBillableDate));

  const notes = [
    { label: "Clinic Notes", unsaved: NOTE_SAVE_HANDLERS.CLINIC_NOTE_UNSAVED },
    {
      label: getProviderNoteTitle(accountsMapper, reportDetail?.account),
      unsaved: NOTE_SAVE_HANDLERS.PROVIDER_NOTE_UNSAVED,
    },
    { label: "Report Notes", unsaved: NOTE_SAVE_HANDLERS.REPORT_NOTE_UNSAVED },
    { label: "Billing Date", unsaved: NOTE_SAVE_HANDLERS.BILLING_DATE_UNSAVED },
  ];

  const getUnsavedNotes = () =>
    notes
      .filter((note) => registry?.call(note.unsaved))
      .map((note) => note.label);

  return { hasUnsavedNotes, getUnsavedNotes };
};

export default useUnsavedNotes;
